import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Button from "components/bootstrap/Button";
import bgStemp01 from '../../../../assets/img/background/bgStemp01.png';
import bgStemp02 from '../../../../assets/img/background/bgStemp02.png';
import bgStemp03 from '../../../../assets/img/background/bgStemp03.png';
import bgStemp04 from '../../../../assets/img/background/bgStemp04.png';
import bgStemp05 from '../../../../assets/img/background/bgStemp05.png';
import bgStemp06 from '../../../../assets/img/background/bgStemp06.png';
import bgStemp07 from '../../../../assets/img/background/bgStemp07.png';
import bgStemp08 from '../../../../assets/img/background/bgStemp08.png';
import bgStemp09 from '../../../../assets/img/background/bgStemp09.png';
import bgStemp10 from '../../../../assets/img/background/bgStemp10.png';
import bgStemp11 from '../../../../assets/img/background/bgStemp11.png';
import bgStemp12 from '../../../../assets/img/background/bgStemp12.png';
import bgStemp13 from '../../../../assets/img/background/bgStemp13.png';
import bgStemp15 from '../../../../assets/img/background/bgStemp15.png';
import bgStemp16 from '../../../../assets/img/background/bgStemp16.png';
import bgStemp17 from '../../../../assets/img/background/bgStemp17.png';
import bgStemp18 from '../../../../assets/img/background/bgStemp18.png';
import bgStemp19 from '../../../../assets/img/background/bgStemp19.png';
import bgStemp21 from '../../../../assets/img/background/bg_hd.png';
import bgStemp011 from '../../../../assets/img/background/bgStemp011.png';
import UserService from "services/UserService";
import { useMst } from "models";

/******************************************************************
 * 파일명 : frontend2\src\pages\common\Headers\components\BackgroundSetContent.js
 * 설명 : 상단 util 영역 > 설정 모달 > 배경 이미지
 ******************************************************************/

const BackgroundSetContent = ({
    isOpen,
    setIsOpen
}) => {
    const { t } = useTranslation();
    const {user} = useMst();
    const [saveClass, setSaveClass] = useState('bgStemp01'); // 서버에 저장되어 있는 유저 배경 값
    const [selectedClass, setSelectedClass] = useState('bgStemp01'); // 현재 선택해보는 배경 값

    const imgList = [
        {class:'bgStemp01', src:bgStemp01, alt:'벚꽃 이미지'},
        {class:'bgStemp02', src:bgStemp02, alt:'고양이 이미지'},
        {class:'bgStemp03', src:bgStemp03, alt:'작은 집과 나무가 있는 이미지'},
        {class:'bgStemp04', src:bgStemp04, alt:'분홍색 배경 꽃 이미지'},
        {class:'bgStemp05', src:bgStemp05, alt:'아이스크림 이미지'},
        {class:'bgStemp06', src:bgStemp06, alt:'하늘색 배경 꽃 이미지'},
        {class:'bgStemp07', src:bgStemp07, alt:'눈 덮인 겨울 풍경 이미지'},
        {class:'bgStemp08', src:bgStemp08, alt:'구름이 있는 하늘 이미지'},
        {class:'bgStemp09', src:bgStemp09, alt:'산토리니 바다 풍경 이미지'},
        {class:'bgStemp10', src:bgStemp10, alt:'열대 해변 이미지'},
        {class:'bgStemp11', src:bgStemp11, alt:'안개 낀 숲 이미지'},
        {class:'bgStemp12', src:bgStemp12, alt:'오로라가 있는 밤하늘 이미지'},
        {class:'bgStemp13', src:bgStemp13, alt:'추상적인 구형 이미지'},
        {class:'bgStemp15', src:bgStemp15, alt:'작은 섬과 바다 이미지'},
        {class:'bgStemp16', src:bgStemp16, alt:'알록달록한 건물 이미지'},
        {class:'bgStemp17', src:bgStemp17, alt:'마카롱 이미지'},
        {class:'bgStemp18', src:bgStemp18, alt:'파스텔 색상 추상 이미지'},
        {class:'bgStemp19', src:bgStemp19, alt:'사막과 밤하늘 이미지'},
        {class:'bgStemp21', src:bgStemp21, alt:'선 그림 이미지'},
        {class:'bgStemp011', src:bgStemp011, alt:'바다 위 섬 이미지'},
    ];

    const colorList = [
        {class:'bgColor01', color:'#f3e2c2', ariaLabel:'연한 베이지색'},
        {class:'bgColor02', color:'#edd2a2', ariaLabel:'베이지색'},
        {class:'bgColor03', color:'#dab588', ariaLabel:'연한 갈색'},
        {class:'bgColor04', color:'#c8825e', ariaLabel:'주황빛 갈색'},
        {class:'bgColor05', color:'#c35c50', ariaLabel:'붉은 갈색'},
        {class:'bgColor06', color:'#3f2421', ariaLabel:'진한 갈색'},
        {class:'bgColor07', color:'#f2d9ee', ariaLabel:'연한 분홍색'},
        {class:'bgColor08', color:'#e9bdda', ariaLabel:'분홍색'},
        {class:'bgColor09', color:'#dda4c4', ariaLabel:'연한 자주색'},
        {class:'bgColor10', color:'#af6f80', ariaLabel:'자주색'},
        {class:'bgColor11', color:'#99515b', ariaLabel:'진한 자주색'},
        {class:'bgColor12', color:'#39103c', ariaLabel:'진한 보라색'},
        {class:'bgColor13', color:'#dbd8e7', ariaLabel:'연한 보라색'},
        {class:'bgColor14', color:'#bfbbd7', ariaLabel:'보라색'},
        {class:'bgColor15', color:'#a19cc1', ariaLabel:'연한 보랏빛 회색'},
        {class:'bgColor16', color:'#877eab', ariaLabel:'보랏빛 회색'},
        {class:'bgColor17', color:'#655a92', ariaLabel:'진한 보라색'},
        {class:'bgColor18', color:'#352e52', ariaLabel:'매우 진한 보라색'},
        {class:'bgColor19', color:'#cfdfea', ariaLabel:'연한 하늘색'},
        {class:'bgColor20', color:'#acc7db', ariaLabel:'하늘색'},
        {class:'bgColor21', color:'#608fac', ariaLabel:'청회색'},
        {class:'bgColor22', color:'#095e9d', ariaLabel:'파란색'},
        {class:'bgColor23', color:'#073a88', ariaLabel:'진한 파란색'},
        {class:'bgColor24', color:'#010b4a', ariaLabel:'매우 진한 남색'},
        {class:'bgColor25', color:'#b9dbc6', ariaLabel:'연한 초록색'},
        {class:'bgColor26', color:'#92c7a6', ariaLabel:'연두빛 초록색'},
        {class:'bgColor27', color:'#5bab78', ariaLabel:'초록색'},
        {class:'bgColor28', color:'#459172', ariaLabel:'청록빛 초록색'},
        {class:'bgColor29', color:'#287666', ariaLabel:'진한 청록색'},
        {class:'bgColor30', color:'#1a5448', ariaLabel:'매우 진한 청록색'},
        {class:'bgColor31', color:'#cacaca', ariaLabel:'연한 회색'},
        {class:'bgColor32', color:'#a6a6a6', ariaLabel:'회색'},
        {class:'bgColor33', color:'#878787', ariaLabel:'중간 회색'},
        {class:'bgColor34', color:'#5b5b5b', ariaLabel:'진한 회색'},
        {class:'bgColor35', color:'#404040', ariaLabel:'매우 진한 회색'},
        {class:'bgColor36', color:'#000000', ariaLabel:'검은색'}
    ];

    // 미리보기
    useEffect(() => {
        const rootEl = document.getElementById('root');
            rootEl.classList.add(selectedClass);

        return() => {
            rootEl.classList.remove(selectedClass);
        }
    }, [selectedClass]);

    // unmount 시에만 저장값 복원
    useEffect(() => {
        return() => {
            const rootEl = document.getElementById('root');
            if(user?.me?.backGroundImg){
                rootEl.classList.add(user.me.backGroundImg);
            }else{
                // 만약 기본 배경을 바꾸게 된다면 App.js의 기본 배경 값도 바꿔줘야 함
                rootEl.classList.add('bgStemp01');
            }
        }
    }, []);

    // 저장된 값 가져오기
    useEffect(() => {
        if(isOpen && user?.me?.backGroundImg){
            setSaveClass(user.me.backGroundImg);
            setSelectedClass(user.me.backGroundImg);
        }
    }, [isOpen, user]);

    // 닫기 버튼 로직
    const handleCancel = () => {
        setSelectedClass(saveClass); // 닫기시 원래 저장되어 있던 배경 값으로 변경
        setIsOpen(false);
    };

    // 변경 버튼 로직
    const handleSave = async () => {
        try{
            await UserService.update({
                id: user?.me?.id,
                backGroundImg: selectedClass
            });

            setSaveClass(selectedClass);
            user.setBackGroundImg?.(selectedClass);
        } catch (error){
            console.error('배경 저장 실패', error);
        }
    };

    return(
        <div className="bg_content">
            <dl>
                <dt>{t('배경 이미지')}</dt>
                <dd>
                    <ul className="img_list">
                        {imgList.map((v) => {
                            return(
                                <li
                                    key={v.class}
                                    className={`${v.class} ${selectedClass === v.class ? 'selected' : ''}`}
                                >
                                    <Button onClick={() => {setSelectedClass(v.class)}}>
                                        <img src={v.src} alt={v.alt} />
                                    </Button>
                                </li>
                            )
                        })}
                    </ul>
                </dd>
                <dt>{t('배경 색상')}</dt>
                <dd>
                    <ul className="color_list">
                        {colorList.map((v) => {
                            return(
                                <li
                                    key={v.class}
                                    className={`${v.class} ${selectedClass === v.class ? 'selected' : ''}`}
                                >

                                    <Button
                                        style={{background:v.color}}
                                        ariaLabel={v.ariaLabel}
                                        onClick={() => {setSelectedClass(v.class)}}
                                    />
                                </li>
                            )
                        })}
                    </ul>
                </dd>
            </dl>

            <div className="btn_box">
                <Button
                    type='button'
                    className='me-1'
                    color='info'
                    isOutline
                    onClick={handleCancel}
                >{t('닫기')}</Button>
                <Button
                    type='button'
                    color='info'
                    onClick={async () => {
                        await handleSave();
                        setIsOpen(false);
                    }}
                >{t('변경')}</Button>
            </div>
        </div>
    )
};

export default BackgroundSetContent;